export default "__VITE_ASSET__1b801030__"